export default __webpack_public_path__ + "static/media/dna-background.c4384ca7.mp4";